"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="hero" className="relative w-full min-h-[35vh] flex flex-col lg:flex-row bg-background overflow-hidden">
      {/* Bloc texte – gauche */}
      <div className="w-full flex flex-col justify-center px-6 py-10 z-10 !bg-[#F5EDE8] lg:w-1/2 lg:p-10 xl:p-14">
        <div ref={ref} className={`max-w-2xl mx-auto lg:mx-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight font-bold mb-2 text-[hsl(343,80%,35%)] tracking-tight">
            Co-construire la performance
          </h1>

          <p className="font-serif italic text-base md:text-lg mb-4 text-[hsl(343,80%,35%)/80]">
            Christelle CHARRIER-ROBELIN — Consultante experte en formation professionnelle
          </p>

          <p className="font-sans text-base md:text-lg mb-6 text-[hsl(210,10%,23%)] max-w-xl leading-relaxed">
            Je suis <strong>Christelle CHARRIER-ROBELIN</strong>, fondatrice
            d'Effet Conseil. Depuis plus de 20 ans dans l'univers de la
            formation professionnelle, je mets une expérience opérationnelle
            et une maîtrise des cadres réglementaires au service des
            organismes de formation et des organismes certificateurs, dans une
            approche éthique et responsable.
          </p>

          <Button asChild size="lg" className="!bg-[hsl(343,80%,35%)] text-white hover:!bg-[hsl(343,80%,30%)] rounded-sm font-sans text-base px-8 py-5 h-auto shadow-xl hover:shadow-2xl transition-all duration-300">
            <Link to="/ContactPage">
              Échanger sur votre projet
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>

      {/* Bloc photo – droite */}
      <div className="w-full lg:w-1/2 relative min-h-[30vh] lg:min-h-[35vh]">
        <img src="https://working-starling.10web.cloud/wp-content/uploads/2026/03/image_gy8r7uz5.jpg" alt="Christelle Charrier-Robelin – Consultante Effet Conseil" className="absolute inset-0 w-full h-full object-cover object-[center_15%]" />
        <div className="hidden lg:block absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#F5EDE8]/40 to-transparent pointer-events-none" />
      </div>
    </section>;
}